import { postRequest } from "../config/axiosConfig";
import { AuthResponse, ResendTanRequest, ValidateTanRequest } from "../interfaces/auth.interface";

class AuthService {
    baseUrl: string;
    pathname: string;

    constructor(pathname: string) {
        this.baseUrl = 'auth';
        this.pathname = pathname;
    }
    async auth(body: any, captchaToken: string): Promise<{ status: number; data: AuthResponse }> {
        const url = `${this.pathname ? `${this.pathname}/` : ''}${this.baseUrl}`;
        const headers = { 'Content-Type': 'application/json', 'frc-captcha-solution': captchaToken };
        const { status, data } = await postRequest(url, body, headers);
        return {
            status: status,
            data: data,
        };
    }
    async validateTan(body: ValidateTanRequest): Promise<{ status: number; data: AuthResponse }> {
        const { status, data } = await postRequest(`${this.baseUrl}/validatetan/`, body);
        return {
            status: status,
            data: data,
        };
    }
    async resendTan(body: ResendTanRequest): Promise<{ status: number; data: AuthResponse }> {
        const { status, data } = await postRequest(`${this.baseUrl}/resendTan/`, body);
        return {
            status: status,
            data: data,
        };
    }
}

export default AuthService;
